import AppRouter from './components/AppRouter';

export default function App() {
  return <AppRouter />;
}
